import React, { useState } from "react";
import categoryData from "../../api/categories";
import { formatPage } from "../../utils/formatPage";
import { motion, AnimatePresence } from "framer-motion";
import "./OffcanvasMenu.css";
import { useTranslation } from "react-i18next";
export default function OffcanvasMenu({ isOpen, onClose }) {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState(null);

  if (!isOpen) return null;

  const toggleSubMenu = (menu) => {
    if (!menu.subcategories || menu.subcategories.length === 0) {
      window.location.href = `/category/${formatPage(menu.categoryname)}`;
    } else {
      if (selectedCategory && selectedCategory.id === menu.id) {
        setSelectedCategory(null);
      } else {
        setSelectedCategory(menu);
      }
    }
  };

  return (
    <>
      <motion.div
        initial={{ x: -500, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -500, opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="offcanvas offcanvas-start show"
        style={{
          width: "450px",
          visibility: "visible",
          zIndex: 1045,
          backgroundColor: "white",
        }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title px-3 fw-light txtcolor">
            {t("Menu")}
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              setSelectedCategory(null);
              onClose();
            }}
          ></button>
        </div>

        <div className="offcanvas-body">
          {categoryData.category.map((cat) => {
            const isSelected =
              selectedCategory && selectedCategory.id === cat.id;
            return (
              <motion.button
                key={cat.id}
                className={`position-relative btn txtcolor text-start w-100 txtcolor fs-6 mb-1 px-4 py-2 text-decoration-none ${
                  isSelected ? "fw-bold txtcolor active-category " : ""
                }`}
                onClick={() => toggleSubMenu(cat)}
                whileHover={{ scale: 1.01 }}
              >
                <span className="menu-arrow">&gt;</span>
                <span className="underline-wrapper">
                  {/* {cat.categoryname} */}
                  {t(cat.translationKey) || cat.categoryname}
                  <motion.span
                    layoutId="underline"
                    className="underline"
                    initial={false}
                    animate={{ width: isSelected ? "100%" : "0%" }}
                    transition={{ duration: 0.3 }}
                  />
                </span>
              </motion.button>
            );
          })}
        </div>
      </motion.div>

      <AnimatePresence>
        {selectedCategory && (
          <motion.div
            initial={{ x: 500, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 500, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="offcanvas offcanvas-start show"
            style={{
              width: "450px",
              left: "450px",
              visibility: "visible",
              backgroundColor: "white",
              zIndex: 1050,
            }}
          >
            <div className="border-bottom">
              <img
                src={selectedCategory.categorybanner}
                alt={selectedCategory.categoryname}
                className="w-100 mb-0 pt-0"
              />
              <h5 className="offcanvas-title py-3 text-center txtcolor">
                {selectedCategory.categoryname}
              </h5>
            </div>

            <div className="offcanvas-body ">
              {selectedCategory.subcategories.length > 0 ? (
                selectedCategory.subcategories.map((sub) => (
                  <a
                    key={sub.id}
                    href={`/${formatPage(
                      selectedCategory.categoryname
                    )}/${formatPage(sub.name)}`}
                    className="submenu-link  d-block pb-0 fs-6 mb-2 mx-2 txtcolor"
                  >
                    <span className="menu-arrow mt-1">&gt;</span>
                    <span className="underline-wrapper mx-3">
                      {sub.name}
                      <span className="underline"></span>
                    </span>
                  </a>
                ))
              ) : (
                <p className="mt-3 text-muted text-center">Alt kategori yok</p>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          backdropFilter: "blur(6px)",
          WebkitBackdropFilter: "blur(6px)",
          zIndex: 1040,
        }}
        onClick={() => {
          setSelectedCategory(null);
          onClose();
        }}
      ></div>
    </>
  );
}
